export const getDefaultDevice = (devices: MediaDeviceInfo[], preferredDeviceId: string = 'communications') => {
  return devices.find((device) => device.deviceId === preferredDeviceId) || devices[0];
};
